// MIT License

// Copyright (c) 2019 Dennis Morello

// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:

// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.

// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.

// The MIT License (MIT)

// Copyright (c) 2015 Jason

// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:

// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.

// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.

import React from 'react'
import './AboutStyle.css'
import owner from '../images/aboutuspage/owner.webp'
import why from '../images/aboutuspage/whyus.webp'
import Corousel from "../components/MyCorousel"
import { Fade } from "react-awesome-reveal";
import { Slide } from "react-awesome-reveal";
import { Zoom } from "react-awesome-reveal";
import LazyLoad from 'react-lazy-load';
import wave from "../images/wave.webp"
const About = () => {
  document.title = "About";
  return (
    <>
      <div className="headerback">
        <div className="heading">
          <h2> <Fade triggerOnce={true} delay={500} duration={1500}>ABOUT US</Fade></h2>
        </div>
      </div>
      <img src={wave} alt="" className="waveimg" />

      {/* -------------------------------------------------------------------- */}
      <div className="overviewdiv1">
        <Slide triggerOnce={true} duration={1000} direction='up'>
          <div className="overviewhead">
            <p className="title">ABOUT PRATHAM INVESTMENTS</p>
          </div>
          <div className="overviewinfo">
            As financial product distributors, we offer an access to a wide range of financial products that helps you to implement your goals effectively and more importantly, as per your risk profile and needs.
            We provide professional investment management services that allow investors to reach their investment goals quickly and with minimal risk to define clear, achievable and measurable outcome. Pratham Investments takes great pride in its culture of transparency and integrity. Timely delivery of quality services as per customer needs is the reason why clients prefer Pratham Investments. In an attempt to increase footprint across the world, we offer services to NRIs as well.
            Our mission is to provide our clients with the comprehensive, competent, customised and best solutions in wealth creation and wealth management areas.
          </div>
        </Slide>
      </div>

      <Fade triggerOnce={true} delay={200} duration={1500} direction='up'>
        {/* <Fade triggerOnce={true} delay={200} duration={1000} direction='up'> */}
        <div className="ourstoryheader">OUR STORY</div>
        {/* </Fade> */}
        <div className="overview">
          <div className="overviewdiv2outer">
            <div className="overviewdiv2">
              <div className="ownerimg">
                <img src={owner} alt="" className='image1' />
                <p id='ownername'>Mr. Prathmesh Kishor Khachane</p>
                <p id='founder'>(Founder)</p>
              </div>
              {/* </Fade> */}
              <div className="ownerinfo">
                {/* <Fade triggerOnce={true} delay={200} duration={1000} direction='up' > */}
                <div>
                  {/* <p className="title2" id='prathmesh'>PRATHMESH KISHOR KHACHANE</p> */}
                  <p>
                    At the age of 24yrs Prathmesh has chosen a business as a career and with this thought about building up own empire, he started his own financial consultancy named “Pratham Investments”. Prathmesh holds a degree of MBA in Financial Markets. He is also a Certified Financial Goal Planner.
                    Prathmesh has been conducting financial wellness workshops for individuals, families and corporates which aim to educate and help them in any walk of life to grow their hard-earned income. He has numerous clients working with various MNCs, also the Doctors, Businessmen, Advocates, Pilots and many more.
                    He is managing assets worth few hundred crores, his firm “Pratham Investments” designs tailored investment strategy through customised financial planning for individuals and NRI’s. His ability is to evaluate the fluctuations in the stock market and providing critical investment information to clients. He is engaged constantly in learning new technologies to stay current in this ever changing industry. His love for running marathons and exploring a city on the foot, keeps the business growing but grounded. Everyone has the right to a healthy financial life, and offering unbiased, affordable and holistic investment plans is our aim.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fade>


      <div className="overviewhead">
        <p className="title" id='whyusdisplay'>WHY CHOOSE US?</p>
      </div>

      <div className="whyus">
        <div className="container">
          {/* ------------------------------------------------------------------------------ */}
          <div className="whyushead">
            <div className="whydiv1">
              <div className="why1">
                <p className="title2">Client Centric Approach</p>
              </div>
              <div className="why2">
                <p className="title2">Rich Product Basket</p>
              </div>
              <div className="why1">
                <p className="title2">Focus on Customer Satisfaction</p>
              </div>
            </div>

            <Zoom triggerOnce={true} delay={200} duration={1200}>
              <div className="whydiv2">
                <img src={why} alt="" className='image3' />
              </div>
            </Zoom>

            <div className="whydiv1">

              <div className="why1">
                <p className="title2">Driven by Passion</p>
              </div>
              <div className="why2">
                <p className="title2">Focus on Customer Satisfaction</p>
              </div>
              <div className="why2">
                <p className="title2">Right Experience & Skills</p>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div className="leftsec">

        <div><p className="corouseltitle">OUR ACHIEVEMENTS</p></div>
        <div className="achievements">
          <LazyLoad height='100%' width='100%' offset={1000}>
            <Corousel></Corousel>
          </LazyLoad>
        </div>
      </div>
    </>
  )
}

export default About
